module.exports = __webpack_public_path__ + "static/media/process-automation.d7de2620.md";